import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { PublishTesterResultsButton } from "components/flexible_testing/shared/publish_tester_results_button";
import { Participant } from "components/flexible_testing/shared/chat";

type PublishResultsCellProps = {
  participant: Participant;
  testId: string;
};

const CannotBePublishedMessage = ({ tooltipMessage }: { tooltipMessage: string }) => (
  <span className="text-secondary text-sm text-center">
    Cannot be published
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="issue-generation-processing-tooltip">{tooltipMessage}</Tooltip>}
    >
      <i className="inline ml-1 fa fa-info-circle text-dark" aria-hidden="true" />
    </OverlayTrigger>
  </span>
);

const PublishResultsCell = ({ participant, testId }: PublishResultsCellProps) => {
  if (participant.status === "results_published") {
    return <span className="mt-1 text-secondary text-sm text-center">Already published</span>;
  } else if (participant.issueGenerationProcessing) {
    return (
      <CannotBePublishedMessage tooltipMessage="Bug generation is still processing. Please try again in 5 minutes." />
    );
  } else if (participant.issueGenerationFailed) {
    return <CannotBePublishedMessage tooltipMessage="Bug generation failed. Please contact #tech-help for support." />;
  } else if (participant.resultsPublishable) {
    return (
      <span onClick={event => event.stopPropagation()} className="cursor-default">
        <PublishTesterResultsButton participant={participant} testId={testId} />
      </span>
    );
  }

  return <></>;
};

export default PublishResultsCell;
